module.exports = __webpack_public_path__ + "static/media/Cyno.c4f05fb0.png";